var _g, _path, _path2, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublisher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 129,
    viewBox: "0 0 141 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_525_5489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.186 94.4052C108.045 83.3574 98.3206 75.0195 86.6422 75.0195C74.9637 75.0195 65.2397 83.3574 63.098 94.4052C62.6337 96.7894 64.5189 99.0003 66.9447 99.0003H106.333C108.765 99.0003 110.644 96.7963 110.179 94.4052H110.186Z",
    fill: "#53E1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6416 69.3847C93.2178 69.3847 98.5488 64.0537 98.5488 57.4775C98.5488 50.9013 93.2178 45.5703 86.6416 45.5703C80.0654 45.5703 74.7344 50.9013 74.7344 57.4775C74.7344 64.0537 80.0654 69.3847 86.6416 69.3847Z",
    fill: "#53E1F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.186 94.4052C108.045 83.3574 98.3206 75.0195 86.6422 75.0195C74.9637 75.0195 65.2397 83.3574 63.098 94.4052C62.6337 96.7894 64.5189 99.0003 66.9447 99.0003H106.333C108.765 99.0003 110.644 96.7963 110.179 94.4052H110.186Z",
    fill: "#53E1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6416 69.3847C93.2178 69.3847 98.5488 64.0537 98.5488 57.4775C98.5488 50.9013 93.2178 45.5703 86.6416 45.5703C80.0654 45.5703 74.7344 50.9013 74.7344 57.4775C74.7344 64.0537 80.0654 69.3847 86.6416 69.3847Z",
    fill: "#53E1F2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_525_5489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6258 93.2404C74.9367 79.3925 62.7453 68.9338 48.1073 68.9338C33.4694 68.9338 21.278 79.3925 18.5888 93.2404C18.0066 96.2345 20.3631 98.9999 23.4127 98.9999H72.795C75.8446 98.9999 78.2011 96.2345 77.6189 93.2404H77.6258Z",
    fill: "url(#paint0_linear_525_5489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1073 69.1071C62.588 69.1071 74.6608 79.4017 77.4149 93.0671H77.4087L77.4488 93.2735C78.0095 96.1569 75.7395 98.8266 72.795 98.8266H23.4127C20.4682 98.8266 18.1982 96.1569 18.7589 93.2735L18.7589 93.2734C21.4326 79.5054 33.5539 69.1071 48.1073 69.1071Z",
    stroke: "url(#paint1_linear_525_5489)",
    strokeWidth: 0.346543
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_525_5489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5241 61.4737C59.545 59.5806 64.5126 51.5437 62.6195 43.5228C60.7264 35.5019 52.6895 30.5344 44.6686 32.4275C36.6477 34.3206 31.6802 42.3574 33.5733 50.3783C35.4664 58.3992 43.5032 63.3668 51.5241 61.4737Z",
    fill: "url(#paint2_linear_525_5489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4508 43.5626C64.322 51.4904 59.4121 59.4339 51.4843 61.305C43.5566 63.1761 35.613 58.2663 33.7419 50.3385C31.8708 42.4108 36.7807 34.4672 44.7084 32.5961C52.6362 30.725 60.5797 35.6348 62.4508 43.5626Z",
    stroke: "url(#paint3_linear_525_5489)",
    strokeWidth: 0.346543
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_525_5489",
    x: 33.2247,
    y: 15.7676,
    width: 106.828,
    height: 113.035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.9013,
    result: "effect1_foregroundBlur_525_5489"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_525_5489",
    x: 6.02446,
    y: 56.4583,
    width: 84.1591,
    height: 55.0172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.23777
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_525_5489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_525_5489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_525_5489",
    x: 20.6954,
    y: 19.5496,
    width: 54.8017,
    height: 54.8019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.23777
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_525_5489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_525_5489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_525_5489",
    x1: 21.8426,
    y1: 97.3025,
    x2: 43.3772,
    y2: 54.8954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_525_5489",
    x1: 22.6794,
    y1: 71.2985,
    x2: 42.2017,
    y2: 112.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_525_5489",
    x1: 38.2538,
    y1: 62.8746,
    x2: 57.9389,
    y2: 31.0266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_525_5489",
    x1: 32.735,
    y1: 37.6557,
    x2: 63.1422,
    y2: 57.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublisher);
export default __webpack_public_path__ + "static/media/publisher.04de6e44adcea5faf7b6bed56261718c.svg";
export { ForwardRef as ReactComponent };